/**
 * @author Fernando FH
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";
import ServicePath from "@/core/ServicePath";

export default class ColposcopyHistoryService extends MainService {

    static listAllPagination(params) {
        return this.postSEC(ServiceConstant.COLPOSCOPY_LIST_HISTORY_PAGINATION, params);
    }

    static get(params) {
        return this.postSEC(ServiceConstant.COLPOSCOPY_GET_HISTORY, params);
    }

    static update(params) {
        return this.postSEC(ServiceConstant.COLPOSCOPY_UPDATE, params);
    }

    static pdf(params) {
        return this.postPDFSEC(ServicePath.COLPOSCOPY_PDF, params);
    }

    static excel(params) {
        return this.postPDFSEC(ServiceConstant.COLPOSCOPY_EXCEL, params);
    }

}